/*
 * @Author: chengyu
 * @Date: 2022-09-29 14:38:18
 * @Description: jsonp 请求适配器
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import jsonp from '../../../utils/jsonp';
import { getTrackParams, trackHttp } from '../../../utils/ubt';
function adapter(request, responseCallback) {
    var timeout = 6 * 1000;
    var baseParams = {
        method: request.method,
        url: request.url,
        headers: request.headers,
        data: request.body,
        timeout: timeout,
        responseType: request.responseType,
    };
    var trackParams = getTrackParams(baseParams);
    var params = __assign(__assign({}, baseParams), { success: function (data) {
            responseCallback({
                statusCode: 200,
                responseText: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                statusMessage: 'ok',
            });
            trackParams.success({
                status: 200,
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                data: data,
            });
        }, fail: function (err) {
            responseCallback({
                statusCode: 0,
                statusMessage: err.message,
            });
            trackParams.fail(err);
        } });
    trackHttp(trackParams);
    if (request.url) {
        jsonp(request.url, { timeout: timeout }, function (err, data) {
            if (err) {
                params.fail(err);
            }
            else {
                params.success(data);
            }
        });
    }
    else {
        params.fail(new Error('unknown request url'));
    }
}
export default adapter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianNvbnAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29yZS9yZXF1ZXN0L2h0dHAvYWRhcHRlci9qc29ucC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHOzs7Ozs7Ozs7Ozs7QUFLSCxPQUFPLEtBQUssTUFBTSxzQkFBc0IsQ0FBQztBQUN6QyxPQUFPLEVBQUUsY0FBYyxFQUFFLFNBQVMsRUFBRSxNQUFNLG9CQUFvQixDQUFDO0FBRS9ELFNBQVMsT0FBTyxDQUNkLE9BQXlCLEVBQ3pCLGdCQUF5QztJQUV6QyxJQUFNLE9BQU8sR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDO0lBQ3pCLElBQU0sVUFBVSxHQUFHO1FBQ2pCLE1BQU0sRUFBRSxPQUFPLENBQUMsTUFBTTtRQUN0QixHQUFHLEVBQUUsT0FBTyxDQUFDLEdBQUc7UUFDaEIsT0FBTyxFQUFFLE9BQU8sQ0FBQyxPQUFPO1FBQ3hCLElBQUksRUFBRSxPQUFPLENBQUMsSUFBSTtRQUNsQixPQUFPLFNBQUE7UUFDUCxZQUFZLEVBQUUsT0FBTyxDQUFDLFlBQVk7S0FDbkMsQ0FBQztJQUNGLElBQU0sV0FBVyxHQUFHLGNBQWMsQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUMvQyxJQUFNLE1BQU0seUJBQ1AsVUFBVSxLQUNiLE9BQU8sRUFBRSxVQUFDLElBQVM7WUFDakIsZ0JBQWdCLENBQUM7Z0JBQ2YsVUFBVSxFQUFFLEdBQUc7Z0JBQ2YsWUFBWSxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDO2dCQUNsQyxPQUFPLEVBQUU7b0JBQ1AsY0FBYyxFQUFFLGdDQUFnQztpQkFDakQ7Z0JBQ0QsYUFBYSxFQUFFLElBQUk7YUFDcEIsQ0FBQyxDQUFDO1lBQ0gsV0FBVyxDQUFDLE9BQU8sQ0FBQztnQkFDbEIsTUFBTSxFQUFFLEdBQUc7Z0JBQ1gsT0FBTyxFQUFFO29CQUNQLGNBQWMsRUFBRSxnQ0FBZ0M7aUJBQ2pEO2dCQUNELElBQUksTUFBQTthQUNMLENBQUMsQ0FBQztRQUNMLENBQUMsRUFDRCxJQUFJLEVBQUUsVUFBQyxHQUFVO1lBQ2YsZ0JBQWdCLENBQUM7Z0JBQ2YsVUFBVSxFQUFFLENBQUM7Z0JBQ2IsYUFBYSxFQUFFLEdBQUcsQ0FBQyxPQUFPO2FBQzNCLENBQUMsQ0FBQztZQUNILFdBQVcsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDeEIsQ0FBQyxHQUNGLENBQUM7SUFFRixTQUFTLENBQUMsV0FBVyxDQUFDLENBQUM7SUFFdkIsSUFBSSxPQUFPLENBQUMsR0FBRyxFQUFFO1FBQ2YsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsRUFBRSxPQUFPLFNBQUEsRUFBRSxFQUFFLFVBQUMsR0FBRyxFQUFFLElBQUk7WUFDeEMsSUFBSSxHQUFHLEVBQUU7Z0JBQ1AsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQzthQUNsQjtpQkFBTTtnQkFDTCxNQUFNLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQ3RCO1FBQ0gsQ0FBQyxDQUFDLENBQUM7S0FDSjtTQUFNO1FBQ0wsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLEtBQUssQ0FBQyxxQkFBcUIsQ0FBQyxDQUFDLENBQUM7S0FDL0M7QUFDSCxDQUFDO0FBRUQsZUFBZSxPQUFPLENBQUMifQ==